import axios from 'axios';
import useSWR from 'swr';

const useUsers = (companyUid) => {
  const url = `/admin/user?companyUid=${companyUid}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

const useSelf = () => {
  const url = `/self`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useUsers, useSelf };
